import ReactDOM from 'react-dom/client'
import { App } from './App'
import '../styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root not found')
ReactDOM.createRoot(root).render(<App />)
